import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GoBackButtonService } from './go-back-button.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-go-back-button',
	templateUrl: './go-back-button.component.html',
	styleUrls: [ './go-back-button.component.scss' ]
})
export class GoBackButtonComponent implements OnInit {
	private subscription: Subscription = new Subscription();
	backRoute: string = '';

	constructor(private goBackButtonService: GoBackButtonService, private router: Router) {
		const subscription = this.goBackButtonService.backRoute$.subscribe((value) => {
			this.backRoute = value ? value : '/';
		});
		this.subscription.add(subscription);
	}

	ngOnInit() {}

	goBack() {
		const targetRoute = this.backRoute ? this.backRoute : '/';
		this.router.navigate([ targetRoute ]);
	}
}
